// extracted by mini-css-extract-plugin
export default {"containerLarge":"style_containerLarge__a3GCi"};